import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { Toolbar } from 'primereact/toolbar';
import { RemainingOriginalListShowColumns } from '../../../appconfig/DatatableSetting';
import { applicationsDOBTemplate, RegDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { REMAINING_OC_LIST } from '../../../config/ApiConstant';
import { getAllDetails } from '../../../service/ProductService';

export const RemainingOriginalCertificateList = () => {
    document.title = 'Remaining Original Certificate List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [certificateList, setCertificateList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getCertificateList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get certificate list
    const getCertificateList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(REMAINING_OC_LIST);
            if (response) {
                setPageLoad(true);
                setCertificateList(response);
            }
        } catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Template for PAddress
    const PAddressTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={rowData?.PAddress} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.PAddress) ? rowData.PAddress : ''}</div>
                </Button>
            </>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Certificate'} pageName={'Remaining Original Certificate List'} pageTitle={'Remaining Original Certificate List'} goToPage={true} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                    removableSort
                                >
                                    {RemainingOriginalListShowColumns.map((col, i) => {
                                        if (col.field === 'BOD') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsDOBTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegDtTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'PAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={PAddressTemplate} />;
                                        } else if (col.field === 'SrNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '9rem' }} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '9rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RemainingOriginalListShowColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
